/**
 * ButtonGroup Component
 *
 * Segmented button group for single-select options.
 */

import React from 'react';

interface ButtonGroupProps {
  options: Array<{ value: string; label: string }> | string[];
  value: string;
  onChange: (value: string) => void;
  size?: 'sm' | 'md';
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  options,
  value,
  onChange,
  size = 'md',
}) => {
  const normalizedOptions = options.map((opt) =>
    typeof opt === 'string' ? { value: opt, label: opt } : opt
  );

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-2 text-sm',
  };

  return (
    <div className="flex flex-wrap gap-2">
      {normalizedOptions.map((option) => {
        const isSelected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`${sizeClasses[size]} rounded-lg border font-medium transition-colors ${
              isSelected
                ? 'bg-gray-900 text-white border-gray-900'
                : 'bg-white text-gray-700 border-gray-300 hover:border-gray-400'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default ButtonGroup;
